import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactory, ComponentFactoryResolver, ComponentRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ImagesService } from '../../services/utils/images.service';
import { ServicioEncuestaCovidService, EncuestaCovidEntity, EncuestaCovidFormatoEntity, EncuestaCovidPreguntaEntity } from '../../services/servicio-encuesta-covid.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ServicioLoginService, LoginEntity } from '../../services/servicio-login.service';
import { ServicioAfiliadoService, AfiliadoEntity } from '../../services/servicio-afiliado.service';
import { GrupoPreguntaComponent } from './componentes/grupo-pregunta/grupo-pregunta.component';

@Component({
  selector: 'app-reporte-encuesta-covid',
  templateUrl: './reporte-encuesta-covid.component.html',
  styleUrls: ['./reporte-encuesta-covid.component.css']
})
export class ReporteEncuestaCovidComponent implements OnInit {

  loading: boolean;

  logo: string;
  mensajeError: string;
  mensajeLoading: string;
  usuario: string;

  fechaImpresion: Date;

  afiliado: AfiliadoEntity;
  formato: EncuestaCovidFormatoEntity;
  objectEncuesta: EncuestaCovidEntity = {};

  @ViewChild('container', { read: ViewContainerRef}) public container: ViewContainerRef;

  constructor(private activatedRoute: ActivatedRoute,
              private servicioImagenes: ImagesService,
              private servicioEncuesta: ServicioEncuestaCovidService,
              private servicioLogin: ServicioLoginService,
              private servicioAfiliado: ServicioAfiliadoService,
              private componentFactory: ComponentFactoryResolver) {
    this.activatedRoute.params.subscribe(params => {
      this.objectEncuesta.codigo = params['codigoBaseDatos'];
      this.objectEncuesta.uncoAfiliado = Number(params['uncoAfiliado']);
      this.objectEncuesta.uncoSede = Number(params['uncoSede']);
      this.objectEncuesta.uncoLogin = Number(params['uncoLogin']);
    });
  }

  ngOnInit() {
  }

  public onFiltrosCompletados(obj: EncuestaCovidEntity) {
    this.container.clear();
    this.fechaImpresion = new Date();
    this.objectEncuesta = obj;
    this.loading = false;
    this.getLogo();
  }

  async getLogo(){
    try{
      this.logo = '';
      this.loading = true;
      this.mensajeLoading = 'Cargando información de la entidad ...';
      let response = await this.servicioImagenes.getLogo(this.objectEncuesta.codigo);
      if(response != null){
        response.subscribe((data: any) => {
          this.logo = data.source;
          this.getUsuario();
        }, (err: HttpErrorResponse) => {
          this.logo = '';
          this.loading = false;
          this.mensajeError = 'Error al obtener información del logo entidad, verifique su conexión a internet e intente de nuevo. De lo contrario contacto a su administrador.';
        })
      }
    }catch(e){
      this.logo = '';
      this.loading = false;
      this.mensajeError = 'Error grave al obtener información del logo entidad, intente de nuevo o reporte caso al administrador';
    }
  }

  async getUsuario() {
    try {
      this.mensajeLoading = 'Cargando información del usuario ...';
      const response = await this.servicioLogin.getUsuario(this.objectEncuesta.codigo, this.objectEncuesta.uncoLogin);
      if(response != null) {
        response.subscribe((data: LoginEntity) => {
          this.usuario = data.usuario;
          this.getAfiliado();
        }, (err: HttpErrorResponse) => {
          console.error('ReporteEncuestaCovid.getUsuario()', err);
          this.loading = false;
          this.mensajeError = 'Error al obtener información del usuario, verifique su conexión a internet e intente de nuevo. De lo contrario contacto a su administrador.';
        })
      }
    }catch(e) {
      console.error('ReporteEncuestaCovid.getUsuario()', e);
      this.loading = false;
      this.mensajeError = 'Error grave al obtener información del usuario, verifique su conexión a internet e intente de nuevo. De lo contrario contacto a su administrador.';
    }
  }

  async getAfiliado() {
    try {
      this.mensajeLoading = 'Cargando información del afiliado ...';
      const response = await this.servicioAfiliado.getInformacionAfiliado(this.objectEncuesta.codigo, this.objectEncuesta.uncoAfiliado);
      if(response != null) {
        response.subscribe((data: AfiliadoEntity) => {
          this.afiliado = data;
          this.getReporte();
        }, (err: HttpErrorResponse) => {
          console.error('ReporteEncuestaCovid.getAfiliado()', err);
          this.loading = false;
          this.mensajeError = 'Error al obtener información del afiliado, verifique su conexión a internet e intente de nuevo. De lo contrario contacto a su administrador.';
        })
      }
    }catch (e){
      console.error('ReporteEncuestaCovid.getAfiliado()', e);
      this.loading = false;
      this.mensajeError = 'Error grave al obtener información del usuario, verifique su conexión a internet e intente de nuevo. De lo contrario contacto a su administrador.';
    }
  }

  async getReporte() {
    try {
      this.mensajeLoading = 'Cargando información de la encuesta ...';
      const response = await this.servicioEncuesta.getFormatoEncuesta(this.objectEncuesta);
      if(response != null){
        response.subscribe((data: EncuestaCovidFormatoEntity) => {
          this.formato = data;
          this.buildFormato(data);
          this.loading = false;
        }, (err: HttpErrorResponse) => {
          console.error('ReporteEncuestaCovid.getReporte()', err);
          this.loading = false;
          this.mensajeError = 'Error al obtener información de la encuesta, verifique su conexión a internet e intente de nuevo. De lo contrario contacto a su administrador.';
        })
      }
    }catch(e) {
      console.error('ReporteEncuestaCovid.getReporte()', e);
      this.loading = false;
      this.mensajeError = 'Error grave al obtener información de la encuesta, verifique su conexión a internet e intente de nuevo. De lo contrario contacto a su administrador.';
    }
  }

  // Construir
  buildFormato(formato: EncuestaCovidFormatoEntity) {
    this.container.clear();
    let row: ComponentRef<GrupoPreguntaComponent> = null;
    formato.preguntas.forEach((g: EncuestaCovidPreguntaEntity) => {
      row = this.getGrupoPregunta(g);
    })
  }

  getGrupoPregunta(grupo: EncuestaCovidPreguntaEntity) {
    const factory: ComponentFactory<GrupoPreguntaComponent> = this.componentFactory.resolveComponentFactory(GrupoPreguntaComponent);
    const component: ComponentRef<GrupoPreguntaComponent> = this.container.createComponent(factory);
      component.instance.afiliado = this.afiliado;
      component.instance.grupoPregunta = grupo;
      component.instance.resultados = this.formato.respuestas;
    return component;
  }

  // Auxiliar
  getResultado(): { value: string, class: string} {
    const resultado = this.objectEncuesta.encuesta.resultadoEncuesta;
    switch(resultado) {

      case 1: {
        return { value : 'SOSPECHOSO', class : 'caso-sospechoso'};
      }

      case 2 : {
        return { value : 'CONFIRMADO', class : 'caso-confirmado' }
      }

      default :{
          return { value : 'NO SOSPECHOSO', class : 'caso-no-sospechoso'};
      }
    }
  }

  mostrarMensaje(mensaje: string) {
    this.mensajeError = mensaje;
  }

}
